<template lang="pug">
  div
    el-button.ButtonNext(@click="showDialog = true" type="primary" v-show="show || beginShow" v-if="getFeedback.title != null") Retroalimentación
    el-button.ButtonNext(@click="showDialog = true" type="primary" v-show="show || beginShow" v-else) Siguiente
    v-dialog(v-model="showDialog" persistent  max-width="1000px" )
      v-layout(row, justify-center)
        v-flex(text-xs-center)
          v-card
            div(v-if="showDialog")
              v-layout
                v-flex(text-xs-center)
                  img.dialog_img(:src="getImage")
              v-spacer.my-1.py-4
              v-card-text.headline
                p.feedtitle {{ getFeedback.title }}
              v-card.card(flat)
                v-card-text.dialog_text.textos
                  p.text-sm-left.px-4.px-sm-5(v-for="label in getFeedback.labels" v-html="getText(label.text)")
                  v-btn.icone(fab dark icon v-if="getFeedback.list3" @click="changeExtra")
                    v-icon(color="white") add
                  span.extra(v-if="getFeedback.list3") Recuerda que...
                  ul.list1(v-if="this.extra")
                    li(v-for="l in getFeedback.list3") {{l}}
              v-spacer.my-1.py-4
              ButtonNext.buttones(@next="$emit('next')")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import ButtonNext from "@/components/button-next/button-next";
export default {
  name: 'FeedbackUnique',
  components: {
    ButtonNext
  },
props: {        
    beginShow: {
      type: Boolean,
      default: false
    }    
  },
  watch: {
    currentStep: {
      handler(val) {        
        this.show = val.check || false;        
      },
      deep: true
    }
  },
  computed: {
    ...mapActions(['nextStepSCORM']),
    ...mapGetters(['currentStep']),
    getFeedback() {
        let feed = (this.currentStep.feedbacksModal || []).find(f => f.points === this.currentStep.points) || {};
        if(!feed.type) {
          feed = (this.currentStep.feedbacksModal || []).find(f => f.type === 'negative') || {};
        }
        if(feed.title == null){
          this.$emit('next');
          this.nextStepSCORM();
        }
        return feed;
    },
    getImage() {
        return require((this.getFeedback || {}).type === 'positive' ? '@/assets/ManoArriba.png' : '@/assets/ManoStop.png');
    },
    next() {
      this.$emit('next');
      this.nextStepSCORM();
    }
  },
	data(){
    return {
      showDialog: false,
      show: false,
      extra: false
		}
	},
  mounted:function(){
    this.getFeedback();
  },
	methods:{
    changeExtra(){
      this.extra = !this.extra;
    },
		change(){
			this.state = true;
    },
    getText(text) {
      if(text) {
        let replaceData = text.split('|');
        if (replaceData.length > 1) {
          text = text.replace(`|${replaceData[1]}|`, this.currentStep.data[replaceData[1]]);
        }      
      }
      return text;
    }
  }
}
</script>

<style scoped>
@import 'feedback-modal.scss';
</style>
